import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import ErrorBoundary from '../components/ErrorBoundary';
import { HospitalProfileProvider } from '../auth/HospitalProfileContext';

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <HospitalProfileProvider>
      <div className="app-shell">
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
        <main
          className="app-main"
          style={{ marginLeft: collapsed ? 'var(--sidebar-collapsed)' : 'var(--sidebar-width)' }}
        >
          <ErrorBoundary fallback="/manager/dashboard" title="Page error">
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </HospitalProfileProvider>
  );
}
